import { Component } from '@angular/core';

@Component({
  selector: 'app-refresh-tab',
  templateUrl: './refresh-tab.component.html',
  styleUrls: ['./refresh-tab.component.scss']
})
export class RefreshTabComponent {

}
